"use strict";

var _interopRequireDefault3 = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = StepList;

var _extends2 = _interopRequireDefault3(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault3(require("@babel/runtime/helpers/objectWithoutProperties"));

var _interopRequireDefault2 = _interopRequireDefault3(require("@babel/runtime/helpers/interopRequireDefault"));

var _classnames = _interopRequireDefault3(require("classnames"));

var _intl = require("../../utils/intl");

var _propTypes = _interopRequireDefault3(require("prop-types"));

var _react = _interopRequireDefault3(require("react"));

var _TabListBase = _interopRequireDefault3(require("../../TabList/js/TabListBase"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
var intlMessages = {
  "cs-CZ": (0, _interopRequireDefault2["default"])(require("./../intl/cs-CZ.json"))["default"],
  "da-DK": (0, _interopRequireDefault2["default"])(require("./../intl/da-DK.json"))["default"],
  "de-DE": (0, _interopRequireDefault2["default"])(require("./../intl/de-DE.json"))["default"],
  "en-US": (0, _interopRequireDefault2["default"])(require("./../intl/en-US.json"))["default"],
  "es-ES": (0, _interopRequireDefault2["default"])(require("./../intl/es-ES.json"))["default"],
  "fi-FI": (0, _interopRequireDefault2["default"])(require("./../intl/fi-FI.json"))["default"],
  "fr-FR": (0, _interopRequireDefault2["default"])(require("./../intl/fr-FR.json"))["default"],
  "hu-HU": (0, _interopRequireDefault2["default"])(require("./../intl/hu-HU.json"))["default"],
  "it-IT": (0, _interopRequireDefault2["default"])(require("./../intl/it-IT.json"))["default"],
  "ja-JP": (0, _interopRequireDefault2["default"])(require("./../intl/ja-JP.json"))["default"],
  "ko-KR": (0, _interopRequireDefault2["default"])(require("./../intl/ko-KR.json"))["default"],
  "nb-NO": (0, _interopRequireDefault2["default"])(require("./../intl/nb-NO.json"))["default"],
  "nl-NL": (0, _interopRequireDefault2["default"])(require("./../intl/nl-NL.json"))["default"],
  "pl-PL": (0, _interopRequireDefault2["default"])(require("./../intl/pl-PL.json"))["default"],
  "pt-BR": (0, _interopRequireDefault2["default"])(require("./../intl/pt-BR.json"))["default"],
  "ru-RU": (0, _interopRequireDefault2["default"])(require("./../intl/ru-RU.json"))["default"],
  "sv-SE": (0, _interopRequireDefault2["default"])(require("./../intl/sv-SE.json"))["default"],
  "tr-TR": (0, _interopRequireDefault2["default"])(require("./../intl/tr-TR.json"))["default"],
  "uk-UA": (0, _interopRequireDefault2["default"])(require("./../intl/uk-UA.json"))["default"],
  "zh-CN": (0, _interopRequireDefault2["default"])(require("./../intl/zh-CN.json"))["default"],
  "zh-TW": (0, _interopRequireDefault2["default"])(require("./../intl/zh-TW.json"))["default"]
};

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/steplist/index.css");

  require("../../spectrum-css/steplist/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/steplist/index-lg.css");
} else {
  require("../../spectrum-css/steplist/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/steplist/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/steplist/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/steplist/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/steplist/multiStops/darkest.css");
var formatMessage = (0, _intl.messageFormatter)(intlMessages);
var SMALL = 'S';
var LARGE = 'L';
var ON = 'on';
var STEP_ITEM_SELECTOR = '.spectrum-Steplist-link[tabindex]';
var STEP_ITEM_SELECTED_SELECTOR = STEP_ITEM_SELECTOR + '.is-selected';

function StepList(_ref) {
  var className = _ref.className,
      _ref$interaction = _ref.interaction,
      interaction = _ref$interaction === void 0 ? ON : _ref$interaction,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? LARGE : _ref$size,
      _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? formatMessage('Step List') : _ref$ariaLabel,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "interaction", "size", "aria-label"]);
  return _react["default"].createElement(_TabListBase["default"], (0, _extends2["default"])({
    "aria-label": ariaLabel
  }, otherProps, {
    className: (0, _classnames["default"])('react-spectrum-Steplist', 'spectrum-Steplist', {
      'spectrum-Steplist--interactive': interaction === ON,
      'spectrum-Steplist--small': size === SMALL
    }, className),
    role: "list",
    orientation: null,
    itemSelector: STEP_ITEM_SELECTOR,
    selectedItemSelector: STEP_ITEM_SELECTED_SELECTOR,
    disabled: interaction !== ON,
    childMappingFunction: function childMappingFunction() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return getChildProps.apply(void 0, [size].concat(args));
    },
    ignorePageUpPageDown: true,
    loopFocusAtEdges: false
  }));
}

function getChildProps(size, tabList, child, index) {
  return {
    complete: +tabList.state.selectedIndex > index,
    index: index,
    size: size
  };
}

StepList.displayName = 'StepList';
StepList.propTypes = {
  /** Class to add to the step list */
  className: _propTypes["default"].string,

  /** Index of the selected step (uncontrolled state) */
  defaultSelectedIndex: _propTypes["default"].number,

  /** Turn step list interaction (clickable to progress) on or off */
  interaction: _propTypes["default"].oneOf([ON, 'off']),

  /** Index of the selected step */
  selectedIndex: _propTypes["default"].number,

  /** Size of the steps and step list */
  size: _propTypes["default"].oneOf(['S', 'L'])
};
StepList.defaultProps = {
  interaction: ON,
  size: LARGE
};